import { WishlistItem } from "#sitis/internal/controllers/wish/models/WishlistItem";
export class WishUseCase {
  constructor(agent) {
    this.agent = agent;
  }
  async getWishlistItems(params) {
    try {
      const queryParams = [];
      if (params?.extensions?.length) {
        const formattedExtensions = params?.extensions.join(",");
        queryParams.push(`expand=${formattedExtensions}`);
      }
      let query = queryParams.join("&");
      if (query) {
        query = `?${query}`;
      }
      const response = await this.agent.get(`/wishlist${query}`);
      return response._data.map((t) => new WishlistItem(t).toJSON());
    } catch (ex) {
      throw ex;
    }
  }
  async addItemToWishlist(body) {
    try {
      const reqBody = {
        id: body.id
      };
      const response = await this.agent.post("/wishlist", { body: { ...reqBody } });
      return response._data;
    } catch (ex) {
      throw ex;
    }
  }
  async clearWishlist() {
    try {
      const response = await this.agent.delete("/wishlist");
      return true;
    } catch (ex) {
      return false;
    }
  }
  async removeItemFromWishlist(id) {
    try {
      const response = await this.agent.delete(`/wishlist/${id}`);
      return true;
    } catch (ex) {
      throw ex;
    }
  }
}
